import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import Divider from '@segment/matcha/components/Divider'

import DemoForm from '@segment/templates/Forms/DemoForm'

const copy = {
  heading: `Interested in hearing more about how Segment can help you?`,
  description: `Connect with the team to learn how 25,000+ companies use Segment's extensible, scalable platform to turn customer data into revenue-generating experiences.`,
  buttonText: `Get a demo`,
}

const Form: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <Divider />
      <Inner>
        <Typography variant="h3" tag="h2">
          {copy.heading}
        </Typography>
        <Typography variant="pLarge">{copy.description}</Typography>
        <FormWrapper>
          <DemoForm
            isProgressive={true}
            customFormIdentifier="site-customers-detail-demo"
            successMessageAppearance="twilioLight"
          />
        </FormWrapper>
      </Inner>
      <Divider />
    </Wrapper>
  )
}

export default Form

const Wrapper = styled.div``

const Inner = styled.div`
  padding: 16px 0 35px;
`

const FormWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    width: 50%;
  }
`
